import R from 'app/assets/R'
import { PageTitle } from 'app/components/common/PageTitle'
import CheckInServicePlanContainer from 'app/containers/CustomerCare/ImportCheckInServicePlan'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

const CheckInServicePlanPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.customer_care_plan)}</PageTitle>
      <CheckInServicePlanContainer />
    </>
  )
}
const CheckInServicePlanPage = memo(CheckInServicePlanPageCpn, isEqual)

export default CheckInServicePlanPage
